import React, {useContext} from "react";
import PropTypes from "prop-types";
import Spinner from "../../components/Spinner/Spinner";
import {ThemePramsContext} from "../../App";

const CardButton = React.memo(props => {
  const {
    productId,
    productPrice,
    childId,
    loading,
    addCartFunc,
    cartSuccess,
    variationType,
    quantity,
  } = props;

  const isSoldOut = variationType && (quantity === '' || quantity === '0');

  const {productDetailsConfig: {productCardConfig}} = useContext(ThemePramsContext);

  return (
    <button
      className={`product-card__button 
      ${!cartSuccess && loading ? 'is-loading' : ''} 
      ${isSoldOut ? 'is-sold-out' : ''}
      ${(cartSuccess || loading) && 'is-success'}
      `
    }
      onClick={() => addCartFunc( childId ? childId : productId, 1 )}
      disabled={loading || isSoldOut}
      data-product={productId}
      data-price={productPrice}

    >
      {!cartSuccess && loading &&
        <Spinner color='#183f31' size={14} className="product-card__button__load"/>
      }
      {isSoldOut ? "SOLD OUT" :
        <span className="product-card__button__copy">
          {cartSuccess ?
            'Added!'
            : productCardConfig.cardText
          }
        </span>
      }
    </button>
  );
});

CardButton.propTypes = {
  productId: PropTypes.string,
  childId: PropTypes.string,
  loading: PropTypes.bool,
  addCartFunc: PropTypes.func,
  cartSuccess: PropTypes.bool,
  productPrice: PropTypes.number,
  variationType: PropTypes.string,
  quantity: PropTypes.string,
};

export default CardButton;